// extracted by mini-css-extract-plugin
module.exports = {"container":"SuspensionBanner_container__VgzLE","content":"SuspensionBanner_content__2Z9Ip","text":"SuspensionBanner_text__3sC-6"};